import * as $ from 'jquery';

// TH: bootstrap npm package expects to find jquery as window.jQuery... :-(
const oldjquery = (window as any).jQuery;
(window as any).jQuery = $;
// import 'lib/kendo/2014.3.1119/jquery.min';
import 'jquery-migrate';
import 'lib/kendo/2014.3.1119/kendo.datepicker.min';
import 'lib/kendo/2014.3.1119/kendo.timepicker.min';
(window as any).jQuery = oldjquery;


// WEBPACK FOOTER //
// ./lib/kendo-loader.ts